import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import { ProgressTabs } from "ui/tabs";
import { TextTitle } from "ui/text";
import mobileFirstScreenImage from "../../../../../public/assets/platform/ai-decisioning/product-screen-mobile-1.png";
import mobileSecondScreenImage from "../../../../../public/assets/platform/ai-decisioning/product-screen-mobile-2.png";
import mobileThirdScreenImage from "../../../../../public/assets/platform/ai-decisioning/product-screen-mobile-3.png";
import { ScreenOneAnimation } from "./screen-1";
import { ScreenTwoAnimation } from "./screen-2";
import { ScreenThreeAnimation } from "./screen-3";

const firstTabAlt =
  "Heatmap showing conversion rates by marketing campaign and age group, highlighting which campaigns perform best for each audience segment.";
const secondTabAlt =
  "Line chart comparing cumulative new category purchases over time between holdout and treatment groups, illustrating performance lift and progress toward goals.";
const thirdTabAlt =
  "Insights dashboard displaying horizontal bar charts of conversion rates by U.S. state and by age group, with Texas and the 19–35 years segment leading in performance. Charts are sorted by AI to highlight the most significant differences across segments.";

export function AidInsightsSlideshow() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const tabs = [
    {
      id: "aid-tab-1",
      title: "Discover best performing content",
      description:
        "Explore contextual content breakdowns to understand what content resonates most with different segments of your audience and why AI agents decided to send it.",
      media: (
        <ProductShowcase
          variant="poppy"
          mobileProductScreen={<ProductShowcaseImage isMobile src={mobileFirstScreenImage} alt={firstTabAlt} />}
          productScreen={<ScreenOneAnimation isActive={activeTabIndex === 0} />}
        />
      ),
    },
    {
      id: "aid-tab-2",
      title: "Measure performance and lift",
      description:
        "Track how you are progressing towards your goals and measure performance lift vs your holdout group. You define the attribution window and metrics.",
      media: (
        <ProductShowcase
          variant="desert"
          mobileProductScreen={<ProductShowcaseImage isMobile src={mobileSecondScreenImage} alt={secondTabAlt} />}
          productScreen={<ScreenTwoAnimation isActive={activeTabIndex === 1} />}
        />
      ),
    },
    {
      id: "aid-tab-3",
      title: "Learn insights AI agents uncover",
      description:
        "Visualize insights with AI-sorted bar charts showing conversion rates, highlighting top-performing segments, and interesting variances identified by AI agents.",
      media: (
        <ProductShowcase
          variant="autumn"
          mobileProductScreen={<ProductShowcaseImage isMobile src={mobileThirdScreenImage} alt={thirdTabAlt} />}
          productScreen={<ScreenThreeAnimation isActive={activeTabIndex === 2} />}
        />
      ),
    },
  ];

  return (
    <Box as="section" maxW="container.section" mx="auto">
      <TextTitle
        align="center"
        theme="dark"
        size="lg"
        title="Learn alongside AI and uncover insights like never before "
      />

      <ProgressTabs
        mt="biggest"
        mb="small"
        theme="dark"
        tabs={tabs}
        onChangeTab={(index) => {
          setActiveTabIndex(index);
        }}
      />
    </Box>
  );
}
